import * as ngCommon from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppUrlService } from './nav/app-url.service';
import { AppSessionService } from './session/app-session.service';
import { AppUiCustomizationService } from './ui/app-ui-customization.service';
import { DayRolloverService } from './day-rollover/day-rollover.service';
import { CompanyNowService } from './company-now/company-now.service';

@NgModule({
    imports: [
        ngCommon.CommonModule
    ]
})
export class CommonModule {
    static forRoot(): ModuleWithProviders<CommonModule> {
        return {
            ngModule: CommonModule,
            providers: [
                AppSessionService,
                AppUrlService,
                AppUiCustomizationService,
                DayRolloverService,
                CompanyNowService
            ]
        };
    }
}
